import { z } from "zod";

/**
 * Que soporta cada pasarela, segun el backend.
 *
 * Son capacidades de la plataforma, no del gym: cambian con un deploy. Lo que
 * cada gym tiene conectado lo responde el estado de credenciales.
 */
export const gatewayProviderCapabilitiesSchema = z.object({
  // Se llama provider y no key porque es el mismo nombre que usa el resto del
  // modulo: el query param de los filtros, la credencial guardada, la entrada
  // del catalogo de la app.
  provider: z.string(),
  available: z.boolean(),
  subscriptions: z.boolean(),
  // Aparte de subscriptions porque no toda pasarela que cobra en automatico
  // sabe suspender el cobro: Flow solo da de baja.
  //
  // Con default y no requerido: un backend que todavia no lo publique haria
  // fallar el parse de TODO el arreglo, y el fallback —que asume que Flow cobra
  // en automatico— le ganaria a los datos reales que ese backend si estaba
  // mandando. Que falte esconde la pausa hasta el deploy siguiente, que es el
  // lado barato de equivocarse.
  pausableSubscriptions: z.boolean().default(false),
  disputes: z.boolean(),
  oauth: z.boolean(),
});

export const gatewayProviderCapabilitiesResponseSchema = z.object({
  providers: z.array(gatewayProviderCapabilitiesSchema),
});

export type GatewayProviderCapabilities = z.infer<
  typeof gatewayProviderCapabilitiesSchema
>;
